import { render, staticRenderFns } from "./LandingNavigation.vue?vue&type=template&id=5a306c90&"
import script from "./LandingNavigation.vue?vue&type=script&lang=js&"
export * from "./LandingNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports